import { LitElement, css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'

const DELAY = 750;

/**
 * An element specifically for being more explicit and reusable than <div style="display: contents;">
 */
@customElement('ep-clipboard-copy')
export class EPClipboardCopy extends LitElement {

  @property({ reflect: true })
  value: string = ''
  @property({ attribute: 'preview-value', type: Boolean, reflect: true })
  previewValue: boolean = false
  // @query('span[part=particle]')
  // particle?: HTMLSpanElement;
  @property({ attribute: false })
  timeoutID?: number;

  render() {
    return html`
      <overlay-trigger placement="top">
        <clipboard-copy slot="trigger" value=${this.value} @clipboard-copy=${this._handleCopy}>
          <slot part="content"></slot>
        </clipboard-copy>
        <ep-tooltip slot="hover-content" color="light" placement="top">
          ${
            this.timeoutID === undefined
            ? (
              this.previewValue
              ? html`
              Click to copy: ${this.value}
              `
              : html`
              Click to copy
              `
            )
            : html`
              <span slot="icon">✅</span>
              Copied to clipboard
            `
          }
        </ep-tooltip>
      </overlay-trigger>
      
      <!-- <span part="particle">Copied!</span> -->
    `
  }

  private _handleCopy() {
    console.log('timer?', this.timeoutID);
    this.timeoutID = window.setTimeout(() => {
      if (this.timeoutID !== undefined) {

        console.log('resetting')
        this.timeoutID = undefined;
      }
    }, DELAY)
    // if (this.particle) {
    //   //this.particle.style.opacity = '1.0';
    //   this.particle.getAnimations().forEach(anim => anim.cancel())
    //   this.particle.animate([
    //     {
    //       opacity: '1.0',
    //       transform: 'none'
    //     },
    //     {
    //       opacity: '0.0',
    //       transform: 'translate3d(0, -100%, 0)'
    //     }
    //   ], {
    //     duration: DELAY
    //   })
    // }
    //console.log('copied!', this.particle)
  }

  static styles = css`
    :host {
      display: inline-block;
    }

    ::slotted(*), [part=content] {
      text-decoration: underline dotted rgba(0,0,0,0.4);
      text-underline-offset: 5px;
      cursor: pointer;
      transition: text-decoration-color 250ms;
    }
    ::slotted(*:hover), [part=content]:hover {
      text-decoration-color: rgba(0,0,0,0.2);
    }

    [part=particle] {
      color: red;
      position: absolute;
      transition: opacity 500ms;
      opacity: 0;
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-clipboard-copy': EPClipboardCopy
  }
}
